import { jsx as o } from "react/jsx-runtime";
const L = ({
  width: t,
  height: n,
  className: r
}) => /* @__PURE__ */ o(
  "svg",
  {
    className: r,
    fill: "none",
    height: n,
    viewBox: "0 0 23 18",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M9.02501 11.8658L8.64403 16.8906C8.84752 16.8929 9.04892 16.8506 9.23298 16.7669C9.41703 16.6831 9.57895 16.5601 9.70648 16.4072L12.2591 14.1168L17.5478 17.7523C18.5175 18.2593 19.201 17.992 19.4628 16.9141L22.9352 1.6383C23.2408 0.292194 22.4168 -0.234464 21.4715 0.0956754L1.06757 7.43539C-0.32488 7.94338 -0.303484 8.67145 0.831255 9.00258L6.04756 10.5256L18.1691 3.40689C18.7396 3.05219 19.2581 3.24871 18.8313 3.60342L9.02501 11.8658Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  L as Content
};
